import { Fabricante } from './fabricante.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class FabricanteService {

    constructor(private http: Http) {
    }

    getFabricantes(): Observable<Fabricante[]> {
        return this.http.get(`${NTECH_API}/fabricante`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/fabricante/fabricante.service.ts